"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var defaultError = function defaultError() {
  return console.error('No Web3Provider Found.');
}; // tslint:disable-line: no-console


var defaultContext = {
  active: false,
  error: null,
  setConnector: defaultError,
  setFirstValidConnector: defaultError,
  unsetConnector: defaultError,
  setError: defaultError,
  reRenderers: {},
  forceReRender: defaultError
};
exports.default = react_1.createContext(defaultContext);